/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Device from './device';
import DeviceDetail from './device-detail';
import DeviceUpdate from './device-update';
import DeviceDeleteDialog from './device-delete-dialog';

const DeviceRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Device />} />
    <Route path="new" element={<DeviceUpdate />} />
    <Route path=":id">
      <Route index element={<DeviceDetail />} />
      <Route path="edit" element={<DeviceUpdate />} />
      <Route path="delete" element={<DeviceDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DeviceRoutes;
